exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".style_linkableItem__2Jc-m{cursor:pointer}", ""]);

// exports
exports.locals = {
	"linkableItem": "style_linkableItem__2Jc-m"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?modules&camelCase&importLoaders=1&localIdentName=[name]_[local]__[hash:base64:5]!./node_modules/less-loader/dist/cjs.js!./app/components/SimpleDataTable/style.less
// module id = 1911
// module chunks = 8